import React from "react";
import { useParams, useLocation, Link } from "react-router-dom";
import products from "./data/combinedData";
import "./ProductDetail.css";
import logo from"./Images/A.pTechNewLogo_4.png";
import { FaWhatsapp } from "react-icons/fa";

function ProductDetail() {
    const { slug } = useParams();
    const location = useLocation();

    const normalize = (str) =>
        (str || "").toLowerCase().trim().replace(/\s+/g, " ");

    const [rawName, ...casParts] = decodeURIComponent(slug || "").split("-");
    const decodedName = normalize(rawName);
    const decodedCAS = casParts.join("-");

    const product = products.find(
        (p) =>
            normalize(p.productName) === decodedName &&
            normalize(p.casNumber) === normalize(decodedCAS)
    );

    if (!product) {
        return <p className="error">❌ Invalid product link or product not found.</p>;
    }

    // // ✅ Product link same banaya jaise SearchPage me hai
    // const encodedSlug = encodeURIComponent(decodeURIComponent(slug));
    // const productLink = `${window.location.origin}/product/${encodedSlug}`;

    // ✅ Product link same banaya jaise SearchPage me hai
const encodedSlug = encodeURIComponent(decodeURIComponent(slug));
const productLink = `${window.location.origin}/#/product/${encodedSlug}`;


    // ✅ WhatsApp message me product link bhi add kiya
    // const whatsappMessage = `*Hello, I am interested in this product*:\n\n*Product Name*: ${product.productName}\n*Description*: ${product.description}\n\n*View Product*: ${productLink}`;
    const whatsappMessage = `*Hello, I am interested in this product*:\n\n*Product Name*: ${product.productName}\n*Description*: ${product.description}\n\n*View Product*: ${productLink}`;


    const backLink = location.state?.backTo || "/search";

    return (
        <div className="product-detail-wrapper">
            <div className="product-card">
                <div className="product-header">
                    <h2 className="product-title">{product.productName}</h2>
                    <img src={logo} alt="Logo" className="product-logo" />
                </div>

                {/* <div className="product-field1">
                    <span className="field-label">CAS Number:</span>
                    <span className="field-value">{product.casNumber}</span>
                </div> */}

                <div className="product-field">
                    <span className="field-label">Description:</span>
                    <span className="field-value">{product.description}</span>
                </div>

                <div className="product-actions">
                    <a
                        href={`https://wa.me/919999999999?text=${encodeURIComponent(whatsappMessage)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="whatsapp-button"
                    >
                        <FaWhatsapp className="wa-icon" /> Enquire on WhatsApp
                    </a>

                    <Link to={backLink} className="back-button">
                        ← Back to Products
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default ProductDetail;
